import React, { useState } from "react";

const LongText = ({content, limit}) => {
  const [showAll, setShowAll] = useState(false);

  if (content.length <= limit) {
    // there is nothing more to show
    return <p className="band_review_text">{content}</p>;
  }
  if (showAll) {
    // We show the extended text and a link to reduce it
    return (
      <p className="band_review_text">
        {content+' '}
        <a onClick={() => setShowAll(false)} style={{color: "#29a6ed"}}>
          Read less
        </a>
      </p>
    );
  }
  // In the final case, we show a text with ellipsis and a `Read more` button
  const toShow = content.substring(0, limit) + "...";
  return (
    <p className="band_review_text">
      {toShow+' '}
      <a onClick={() => setShowAll(true)} style={{color: "#29a6ed"}}>
        Read more
      </a>
    </p>
  );
};

export default LongText;
